import * as Yup from 'yup'
import { marginFeeValidation } from '../../Steps/MarginFields/validation'
import { DIFFERENT_MARGIN, GENERAL_MARGIN, MARGIN_OPTION, MARGINS, SAME_MARGIN } from '../../Steps/MarginFields/fields'
import {
  DV_360_PROVIDER_PLATFORM,
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM
} from '../../../../../../constants/selectLists/platformList'

export const validationSchema = Yup.object({
  ...marginFeeValidation,
  [GENERAL_MARGIN]: Yup.number().when(MARGIN_OPTION, {
    is: SAME_MARGIN,
    then: () => Yup.number().required('Margin Required').max(100, 'Maximum number of margin - 100%')
  }),
  [MARGINS]: Yup.object().when(MARGIN_OPTION, {
    is: DIFFERENT_MARGIN,
    then: () =>
      Yup.object().shape({
        [FACEBOOK_PROVIDER_PLATFORM]: Yup.number()
          .required('Margin Required')
          .max(100, 'Maximum number of margin - 100%'),
        [GOOGLE_PROVIDER_PLATFORM]: Yup.number()
          .required('Margin Required')
          .max(100, 'Maximum number of margin - 100%'),
        [TIKTOK_PROVIDER_PLATFORM]: Yup.number()
          .required('Margin Required')
          .max(100, 'Maximum number of margin - 100%'),
        [DV_360_PROVIDER_PLATFORM]: Yup.number().required('Margin Required').max(100, 'Maximum number of margin - 100%')
      })
  })
})
